import React from 'react';
import { AlertTriangle } from 'lucide-react';
import AdSlot from '../advertisement/AdSlot';

// Stacks two-up on tablets when it drops below the table, one column beside it on wide screens
// coverage: utils/ipoReviews.js researchCoverage (brokers with published calls)
export const ReviewsSidebar = ({ className = '', coverage = { brokerCount: 0, top: [] } }) => (
  <aside
    className={`grid grid-cols-1 md:grid-cols-2 min-[1440px]:grid-cols-1 gap-5 items-start ${className}`}
    aria-label="Partners and research panel"
  >
    {/* Partner ads (GET /api/ads): dedicated review-page slots first, then the shared ones */}
    <AdSlot slotId={['ipo-reviews-sidebar-top', 'incontent']} variant="compact" />
    <AdSlot slotId={['ipo-reviews-sidebar-bottom', 'infeed']} variant="compact" />

    <section aria-labelledby="contributing-analysts-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2">
        <h2 id="contributing-analysts-heading" className="text-xs font-extrabold uppercase tracking-wider text-slate-700">
          Contributing Brokers
        </h2>
        {coverage.brokerCount > 0 && (
          <span className="text-[11px] font-bold text-[#008080]">
            {coverage.brokerCount} {coverage.brokerCount === 1 ? 'house' : 'houses'}
          </span>
        )}
      </div>
      {coverage.top.length ? (
        <ul className="mt-3 divide-y divide-slate-100">
          {coverage.top.map((broker) => (
            <li key={broker.name} className="flex items-center justify-between gap-3 py-2.5">
              <p className="min-w-0 text-sm font-semibold text-slate-800 truncate" title={broker.name}>
                {broker.name}
              </p>
              <span className="shrink-0 px-2 py-0.5 rounded-md text-[10px] font-bold bg-emerald-50 text-emerald-700">
                {broker.calls} {broker.calls === 1 ? 'call' : 'calls'}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-3 text-xs text-slate-500">Brokers appear here as their research calls are published.</p>
      )}
    </section>

    <section aria-labelledby="sme-liquidity-heading" className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5">
      <h2 id="sme-liquidity-heading" className="flex items-center gap-2 text-sm font-bold text-slate-900">
        <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0" aria-hidden="true" />
        SME Platform Liquidity Risk
      </h2>
      <p className="mt-2 text-xs text-amber-800/90 leading-relaxed">
        SME IPOs have a minimum trading lot size (usually ₹1,00,000 to ₹1,40,000). Unlike mainboard issues, post-listing
        liquidity is constrained. Never invest borrowed capital.
      </p>
    </section>
  </aside>
);

export default ReviewsSidebar;
